import { render, staticRenderFns } from "./StoreUpdate.vue?vue&type=template&id=5b882eaf&"
import script from "./StoreUpdate.vue?vue&type=script&lang=ts&"
export * from "./StoreUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports